/**
 * Clear Storage Utility
 * Clears all localStorage data to ensure fresh login state.
 *
 * @author Civilhealth Development Team
 */

/**
 * Clear all auth-related data from localStorage
 */
export const clearAuthStorage = (): void => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
  localStorage.removeItem('persist:root');
  // Clear any other auth-related keys
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('auth') || key.startsWith('user') || key.startsWith('token')) {
      localStorage.removeItem(key);
    }
  });
};

/**
 * Clear all localStorage (full reset)
 */
export const clearAllStorage = (): void => {
  localStorage.clear();
  sessionStorage.clear();
};

/**
 * Get stored user info for debugging
 */
export const getStoredUserInfo = (): { username?: string; role?: string } | null => {
  try {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      return {
        username: user.username,
        role: user.role,
      };
    }
  } catch (e) {
    console.error('Error parsing stored user:', e);
  }
  return null;
};